<script>
    import {dyData} from 'general/store';

    import s from './style.module.css';
</script>

<div class={s.backdrop} class:s.blur={$dyData.isBackdropBlur} />
